/* eslint-disable react/prop-types */
import React from 'react'

export default function TabPaneIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props?.size || '24'}
      height={props?.size || '24'}
      fill="none"
      viewBox="0 0 24 24"
    >
      <g id="24 / basic / menu">
        <path id="icon" fill="#fff" fillRule="evenodd" d="M22 8V5H2v3zm0 3v3H2v-3zm0 6v3H2v-3z" clipRule="evenodd" />
      </g>
    </svg>
  )
}
